import React from 'react'
import './recommendations.css';
import VideoCard from './videocard' 

function Recommnedations() {
    return (
        <div className="recommnedations">
            <div className="recommended_videos">

                <VideoCard
                    videotitle="How to fool Sangam in ten minutes or less!!"
                    views="978K Views"
                    timestamp="4 days ago"
                    channelName= "Shikhar Sangam"
                    channelLogo="https://avatars3.githubusercontent.com/u/54438024?s=60&v=4"
                    thumbnailImage="https://i.pinimg.com/originals/85/d6/2c/85d62c62a759443923e9ff90eadcfab9.jpg"
                />

                <VideoCard
                    videotitle="How to fool Sangam in ten minutes or less!!"
                    views="978K Views"
                    timestamp="4 days ago"
                    channelName= "Shikhar Sangam"
                    channelLogo="https://avatars3.githubusercontent.com/u/54438024?s=60&v=4"
                    thumbnailImage="https://i.ytimg.com/vi/fSn17ZNfZMc/maxresdefault.jpg"
                />

                <VideoCard
                    videotitle="How to fool Sangam in ten minutes or less!!"
                    views="978K Views"
                    timestamp="4 days ago"
                    channelName= "Shikhar Sangam"
                    channelLogo="https://avatars3.githubusercontent.com/u/54438024?s=60&v=4"
                    thumbnailImage="https://cdn.lyricsmint.com/krishna-kans-trailer-thumb.jpg"
                />

                <VideoCard
                    videotitle="How to fool Sangam in ten minutes or less!!"
                    views="978K Views"
                    timestamp="4 days ago"
                    channelName= "Shikhar Sangam"
                    channelLogo="https://avatars3.githubusercontent.com/u/54438024?s=60&v=4"
                    thumbnailImage="https://i.ytimg.com/vi/fSn17ZNfZMc/maxresdefault.jpg"
                />

                <VideoCard
                    videotitle="How to fool Sangam in ten minutes or less!!"
                    views="978K Views"
                    timestamp="4 days ago"
                    channelName= "Shikhar Sangam"
                    channelLogo="https://avatars3.githubusercontent.com/u/54438024?s=60&v=4"
                    thumbnailImage="https://cdn.lyricsmint.com/krishna-kans-trailer-thumb.jpg"
                />

                <VideoCard
                    videotitle="How to fool Sangam in ten minutes or less!!"
                    views="978K Views"
                    timestamp="4 days ago"
                    channelName= "Shikhar Sangam"
                    channelLogo="https://avatars3.githubusercontent.com/u/54438024?s=60&v=4"
                    thumbnailImage="https://i.ytimg.com/vi/fSn17ZNfZMc/maxresdefault.jpg"
                />

                <VideoCard
                    videotitle="How to fool Sangam in ten minutes or less!!"
                    views="978K Views"
                    timestamp="4 days ago"
                    channelName= "Shikhar Sangam"
                    channelLogo="https://avatars3.githubusercontent.com/u/54438024?s=60&v=4"
                    thumbnailImage="https://i.pinimg.com/originals/85/d6/2c/85d62c62a759443923e9ff90eadcfab9.jpg"
                />

                <VideoCard
                    videotitle="How to fool Sangam in ten minutes or less!!"
                    views="978K Views"
                    timestamp="4 days ago"
                    channelName= "Shikhar Sangam"
                    channelLogo="https://avatars3.githubusercontent.com/u/54438024?s=60&v=4"
                    thumbnailImage="https://cdn.lyricsmint.com/krishna-kans-trailer-thumb.jpg"
                />
                
                <VideoCard
                    videotitle="How to fool Sangam in ten minutes or less!!"
                    views="978K Views"
                    timestamp="4 days ago"
                    channelName= "Shikhar Sangam"
                    channelLogo="https://avatars3.githubusercontent.com/u/54438024?s=60&v=4"
                    thumbnailImage="https://i.pinimg.com/originals/85/d6/2c/85d62c62a759443923e9ff90eadcfab9.jpg"
                />

                <VideoCard
                    videotitle="How to fool Sangam in ten minutes or less!!"
                    views="978K Views"
                    timestamp="4 days ago"
                    channelName= "Shikhar Sangam"
                    channelLogo="https://avatars3.githubusercontent.com/u/54438024?s=60&v=4"
                    thumbnailImage="https://cdn.lyricsmint.com/krishna-kans-trailer-thumb.jpg"
                />

                <VideoCard
                    videotitle="How to fool Sangam in ten minutes or less!!"
                    views="978K Views"
                    timestamp="4 days ago"
                    channelName= "Shikhar Sangam"
                    channelLogo="https://avatars3.githubusercontent.com/u/54438024?s=60&v=4"
                    thumbnailImage="https://i.pinimg.com/originals/85/d6/2c/85d62c62a759443923e9ff90eadcfab9.jpg"
                />

                <VideoCard
                    videotitle="How to fool Sangam in ten minutes or less!!"
                    views="978K Views"
                    timestamp="4 days ago"
                    channelName= "Shikhar Sangam"
                    channelLogo="https://avatars3.githubusercontent.com/u/54438024?s=60&v=4"
                    thumbnailImage="https://i.ytimg.com/vi/fSn17ZNfZMc/maxresdefault.jpg"
                />
                
            </div>
            
        </div>
    )
}

export default Recommnedations
